import React from 'react'
import * as Switch from '@radix-ui/react-switch'
import { useField } from 'formik'
import { FieldWrapper } from './FieldWrapper'


const FormikSwitch = ({ name, label, helpText, wrapped = true }:
  {
    name: string,
    label?: string,
    helpText?: string,
    wrapped?: boolean,
  }) => {
  const [field, meta, helpers] = useField(name)

  return (
    <FieldWrapper
      name={name}
      label={label}
      helpText={helpText}
      error={meta.touched && meta.error ? meta.error : undefined}
      wrapped={wrapped}
    >
      <div className="flex items-center space-x-2">
        <Switch.Root
          checked={field.value}
          onCheckedChange={helpers.setValue}
          className="w-11 h-6 bg-background rounded-full relative data-[state=checked]:bg-primary transition"
        >
          <Switch.Thumb className="block w-5 h-5 bg-white rounded-full shadow transform transition translate-x-0 data-[state=checked]:translate-x-5" />
        </Switch.Root>
      </div>
    </FieldWrapper>
  )
}

export default FormikSwitch;
